import React, { useEffect, useState } from 'react';
import { auth, db } from '../../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { getDatabase, ref, get, query, orderByChild, equalTo } from "firebase/database";
import { Button, Form, FormGroup, Label, Input, Container, Row, Col, CardTitle, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { errorToast, successToast } from '../common/toast';

const Login = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isAdminLogin, setIsAdminLogin] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            if (isAdminLogin) {
                // Admin login with Firebase Auth
                const userCredential = await signInWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;

                if (user) {
                    localStorage.setItem('user', JSON.stringify({ role: 'admin', ...user }));
                    navigate('/admin'); // Redirect to admin dashboard
                    successToast("Admin logged in successfully!");
                } else {
                    setError('Admin role not verified.');
                    errorToast('Admin role not verified.');
                }
            } else {
                const usersRef = ref(db, 'users');
                const userQuery = query(usersRef, orderByChild('userName'), equalTo(email));
                const snapshot = await get(userQuery);

                if (snapshot.exists()) {
                    const userData = Object.values(snapshot.val())[0];

                    if (userData.password === password) {
                        localStorage.setItem('user', JSON.stringify({ uid: userData.id, role: 'user', ...userData }));
                        navigate('/user/');
                        successToast("User logged in successfully!");
                    } else {
                        setError('Incorrect email or password.');
                        errorToast('Incorrect email or password.');
                    }
                } else {
                    setError('No user found with this email.');
                    errorToast('No user found with this email.');
                }
            }
        } catch (error) {
            console.error("error:", error)
            setError('An error occurred during login. Please try again.');
            errorToast('An error occurred during login. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (Object.entries(user)?.length) {
            return navigate(`/${user?.role}`)
        }
    }, [user])

    return (
        <Container className="vh-100">
            <Row className='justify-content-center align-content-center vh-100'>
                <Col lg="4" md="12">
                    <div className='p-3 bg-white'>
                        <CardTitle tag="h4" className="text-center mb-4">Login</CardTitle>

                        <FormGroup className="text-center mb-3">
                            <Label className="form-switch">
                                <Input
                                    type="checkbox"
                                    checked={isAdminLogin}
                                    onChange={() => setIsAdminLogin(!isAdminLogin)}
                                />
                                <span className="slider round me-2"></span>
                                {isAdminLogin ? "Admin Login" : "User Login"}
                            </Label>
                        </FormGroup>

                        <Form onSubmit={handleLogin}>
                            <FormGroup>
                                <Label for="email">Email</Label>
                                <Input
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="password">Password</Label>
                                <Input
                                    type="password"
                                    name="password"
                                    id="password"
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </FormGroup>
                            {error && <div style={{ color: 'red', marginBottom: '15px' }}>{error}</div>}
                            <Button color="primary" block disabled={loading}>
                                {loading && <Spinner size="sm" className='me-2' />}
                                {isAdminLogin ? "Admin Login" : "User Login"}
                            </Button>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
